







import { Component, Prop, Vue } from 'vue-property-decorator';
import BrowseProduct from '@/views/product/widgets/BrowseProduct.vue';
import { ProductTuple } from '@/stores/search/util';

@Component({
  components: {
    BrowseProduct,
  },
})
export default class ProductGrid extends Vue {
  @Prop({required: true})
  private products!: ProductTuple[];
}
